import Logo from 'assets/logo_light.svg';

import styles from './Receipt.module.scss';

export const ReceiptFooter = () => (
  <div className={styles.footer}>
    <img src={Logo} alt="SmartKasa" height={18} />
  </div>
);
